import { FC, Fragment } from 'react';
// i18next
import { Trans, useTranslation } from 'react-i18next';

type Props = {
  label?: string;
  isInitialized?: boolean;
  hideNumbers?: boolean;
  days?: number;
  hours: number;
  minutes: number;
  seconds?: number;
}

const Countdown:FC<Props> = ({ label, isInitialized = false, hideNumbers = false, days, hours, minutes, seconds }) => {
  const { t } = useTranslation();

  const getValue = (value:number) => {
    if (!isInitialized) return '--';
    return value < 10 ? `0${value}` : `${value}`;
  }

  return (
    <div
      className="p-2 sm:p-4 rounded-3xl flex items-center justify-around gap-2 shadow-primary"
      style={{
        minHeight: '108px',
        minWidth: '80%',
      }}
    >
      {isInitialized ? (
        <Fragment>
          {label ? (
            <h2 className={`${hideNumbers ? 'text-center' : 'text-right'} text-lg font-semibold text-primary uppercase`}>
              <Trans t={t} i18nKey={label} components={{ br: <br /> }} />
            </h2>
          ) : null}
          {!hideNumbers ? (
            <Fragment>
              {(days || !seconds) && (
                <div>
                  <h3
                    className="text-4xl text-white text-center"
                    style={{ fontFamily: 'AdvancedLedBoard', textShadow: '0 0 9px rgba(229, 0, 255, 0.54),  0 0 16px rgba(229, 0, 255, 0.54)' }}
                  >
                    {getValue(days || 0)}
                  </h3>
                  <p className="text-primary text-center uppercase">{t('components.countdown.days')}</p>
                </div>
              )}
              <div>
                <h3
                  className="text-4xl text-white text-center"
                  style={{ fontFamily: 'AdvancedLedBoard', textShadow: '0 0 9px rgba(229, 0, 255, 0.54),  0 0 16px rgba(229, 0, 255, 0.54)' }}
                >
                  {getValue(hours)}
                </h3>
                <p className="text-primary text-center uppercase">{t('components.countdown.hours')}</p>
              </div>
              <div>
                <h3
                  className="text-4xl text-white text-center"
                  style={{ fontFamily: 'AdvancedLedBoard', textShadow: '0 0 9px rgba(229, 0, 255, 0.54),  0 0 16px rgba(229, 0, 255, 0.54)' }}
                >
                  {getValue(minutes)}
                </h3>
                <p className="text-primary text-center uppercase">{t('components.countdown.mins')}</p>
              </div>
              {!days && !!seconds && (
                <div>
                  <h3
                    className="text-4xl text-white text-center"
                    style={{ fontFamily: 'AdvancedLedBoard', textShadow: '0 0 9px rgba(229, 0, 255, 0.54),  0 0 16px rgba(229, 0, 255, 0.54)' }}
                  >
                    {getValue(seconds)}
                  </h3>
                  <p className="text-primary text-center uppercase">{t('components.countdown.seconds')}</p>
                </div>
              )}
            </Fragment>
          ) : null}
        </Fragment>
      ) : null}
    </div>
  )
}

export default Countdown;
